export default __webpack_public_path__ + "static/media/mo.df6917fd.svg";